import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotificationPopupIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NotificationPopup",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.07 7.01H4.93A2.94 2.94 0 0 0 2 9.94v12.13A2.94 2.94 0 0 0 4.93 25h22.15a2.94 2.94 0 0 0 2.93-2.93V9.94a2.94 2.94 0 0 0-2.93-2.93Zm-11.41 4.25h10.03c.49 0 .88.39.88.88s-.39.88-.88.88H15.66c-.49 0-.88-.39-.88-.88s.39-.88.88-.88m-7.67 5.1c-1.95 0-3.54-1.57-3.54-3.52S6.02 9.3 7.97 9.3s3.54 1.57 3.54 3.52a3.52 3.52 0 0 1-3.52 3.53Zm18.21 2.49H15.64c-.51 0-.93-.42-.93-.93s.42-.93.93-.93H26.2c.51 0 .93.42.93.93s-.42.93-.93.93"
    })
  }));
};